/**
 * Marine – det levende nettstedet (Håkon 06.10.2026).
 *
 * Marine-sidene har sitt eget, innebygde stilark (designvalg/marine/_ramme) og trenger
 * verken Alpine eller app.css. Fra app.js tar de bare samtykket (banneret og GA4/Meta
 * etter samtykke) og førstepartsmålingen (window.skjld.track → POST /api/t/e), i samme
 * rekkefølge som app.js kjører dem.
 */
import { initConsent } from './consent';
import { initTracking } from './track';
// Lastes DYNAMISK: en statisk import gir en modulepreload på hver eneste side, også de
// uten skjema. Importen skjer bare der skjemaet faktisk står.

initTracking();
initConsent();
// Bloggartiklene og /innsikt rendres av MARINE-rammen, og det er nettopp der
// påmeldingsskjemaet står (Sjur 14.10). Uten dette ville skjemaet der falt tilbake på en
// vanlig sideinnlasting. Kallet er idempotent, så en side som laster begge inngangene
// binder likevel bare én gang.
if (document.querySelector('[data-nyhetsbrev]')) {
    import('./v2-nyhetsbrev').then((m) => m.initNyhetsbrev());
}
